export const timediaUrl = "https://ws.timothee.fr/timedia";
// export const timediaUrl = "http://127.0.0.1:7100";
// export const timediaUrl =
// 	localStorage.getItem("timediaUrl") == null
// 		? "https://ws.timothee.fr/timedia"
// 		: localStorage.getItem("timediaUrl");

//************************************************************************************************************************************************************* */
// STRIPE

// LIBRAIRIE
export const cle_stripe_ljc_publique =
	"pk_live_51Htb74E8tS6wz08wXk49fOzzuxEmnioN6fxHKAfF9Zh9IQ5QwssKyC38Achy74yQswK23owKIvsuoG0ajdfDJVxq00lRMxRu2W";
export const cle_stripe_ljc_publique_TEST =
	"pk_test_51Htb74E8tS6wz08wl5FrF37K2textTEZ9mphGn09JFY37UUCxyS74zC7qo5odKGZjh9CBWNRLeczIwPCvafRWBTW00s6IbN22R";

// ACHAT MEDIA
export const cle_stripe_achatmedia_publique = cle_stripe_ljc_publique;

//************************************************************************************************************************************************************* */
